import { Dialog, HelpDrawerToggle, InfoCircleIcon } from "@cmsgov/ds-medicare-gov";
import { useState } from "react";
import Button from "../../common/components/button";
import X from '../../common/images/x.svg';
import translate from "../../common/functions/translate";
import { helpDrawerClosed, helpDrawerOpened } from "../../common/analytics";

interface MfaHelpDrawerProps {
    toggleClassName?: string
}

export const MfaHelpDrawer = (props: MfaHelpDrawerProps) => {
    const { toggleClassName = 'ds-u-margin-bottom--3' } = props;
    const [showDialog, setShowDialog] = useState(false);

    const drawerHeading = translate("learn_two_step_verification");
    const toggleDialog = () => {
        if (!showDialog) {
            helpDrawerOpened(drawerHeading, drawerHeading, 'mfa');
        } else {
            helpDrawerClosed(drawerHeading, 'mfa');
        }
        setShowDialog(current => !current);
    };

    return (
        <>
            <HelpDrawerToggle
                className={toggleClassName}
                helpDrawerOpen={showDialog}
                showDrawer={toggleDialog}
            >
                {drawerHeading}
                <InfoCircleIcon className="ds-u-margin-left--05"/>
            </HelpDrawerToggle>
            {showDialog && <Dialog
                className={'drawer-dialog'}
                headerClassName={'drawer-dialog-header'}
                underlayClickExits={true}
            >
                <div style={{cursor: 'pointer', float: 'right'}}>
                    <Button
                        aria-label={translate('close')}
                        variation={'ghost'}
                        onClick={toggleDialog}
                        noAnalytics
                    >
                        <img
                            alt={translate('close')}
                            src={X}
                            style={{
                                position: 'relative',
                                bottom: 15,
                                left: 15,
                            }}
                        />
                    </Button>
                </div>
                <div className={'ds-text-heading--2xl ds-u-margin-bottom--3 ds-u-margin-top--0'}>
                    {drawerHeading}
                </div>
                <div className={'ds-text-heading--lg ds-u-margin-bottom--1'}>
                    {translate("what_is_two_step_verification")}
                </div>
                <div className={'ds-text-body--md ds-u-margin-bottom--6'}>
                    {translate("extra_layer")}
                </div>
                <div className={'ds-text-heading--lg ds-u-margin-bottom--1'}>
                    {translate("why_do_need_this")}
                </div>
                <div className={'ds-text-body--md ds-u-margin-bottom--6'}>
                    {translate("keep_info_secure")}
                </div>
                <div className={'ds-text-heading--lg ds-u-margin-bottom--1'}>
                    {translate("how_does_it_work")}
                </div>
                <div className={'ds-text-body--md'}>
                    {translate("send_security_code")}
                </div>
            </Dialog>
            }
        </>
    );
}